import React from "react";
import Container from '@components/ui/container';
import {homeSixHeroBanner as heroBanner,} from '@framework/static/banner';
import {useRouteLang} from "src/hooks/use-route-lang";

const HeroBannerCard = React.lazy(() => import('@components/hero/hero-banner-card'));
const CategoryGridBlock = React.lazy(() => import('@components/common/category-grid-block'));
const NewArrivalsProductFeed = React.lazy(() => import('@components/product/feeds/new-arrivals-product-feed'));
const OneSaleProductFeed = React.lazy(() => import('@components/product/feeds/on-sale-product-feed'));
const CategoryProductFeed = React.lazy(() => import('@components/product/feeds/category-product-feed'));

export default function HomePage() {
    const lang = useRouteLang()
    return (
        <>
            <HeroBannerCard
                lang={lang}
                banner={heroBanner}
                className="hero-banner-six py-20 py:pt-24 mb-5 2xl:bg-center"
            />
            <Container>
                <CategoryGridBlock lang={lang}/>
                <OneSaleProductFeed variant="alpine" lang={lang}/>
                <NewArrivalsProductFeed variant="alpine" lang={lang}/>
                <CategoryProductFeed lang={lang} category="133"/>
                <CategoryProductFeed lang={lang} category="136"/>
            </Container>
        </>
    );
}
